import { render, staticRenderFns } from "./BoletosPagosModal.vue?vue&type=template&id=aba13a36&scoped=true"
import script from "./BoletosPagosModal.vue?vue&type=script&lang=js"
export * from "./BoletosPagosModal.vue?vue&type=script&lang=js"
import style0 from "./BoletosPagosModal.vue?vue&type=style&index=0&id=aba13a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba13a36",
  null
  
)

export default component.exports